import React, { Component } from 'react';

export default class Faq extends Component {
  render() {
    return (
      <div>
        {/* Page Title */}
        <section className="page-title bg-1">
          <div className="overlay"></div>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="block text-center">
                  <span className="text-white">Frequently Asked Questions</span>
                  <h1 className="text-capitalize mb-5 text-lg">FAQ</h1>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="section faq-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <h2 className="text-md mb-2 text-center">Your Questions Answered</h2>
                <div className="divider mx-auto my-4"></div><br/><br/>
                {faqData.map((faq, index) => (
                  <div key={index} className="mb-4">
                    <h5 className="font-weight-bold">{faq.question}</h5>
                    <p className="text-muted">{faq.answer}</p>
                    <hr />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

// FAQ content
const faqData = [
  {
    question: 'Who can join Varenya Matrimonial?',
    answer: 'Varenya Matrimonial is exclusively for individuals from the Brahmin community looking for meaningful life partnerships.'
  },
  {
    question: 'What is the registration fee?',
    answer: 'We are offering a limited-time discount — get a one-year membership for just ₹800 instead of ₹1200.'
  },
  {
    question: 'How can I register?',
    answer: 'Click on "Register Now" from the home or pricing page, or simply call us — we’ll do it for you!'
  },
  {
    question: 'How is Varenya Matrimonial different from other platforms?',
    answer: 'We focus exclusively on the Brahmin community with a verified and respectful environment, ensuring compatibility based on tradition, values, and lifestyle.'
  },
  {
    question: 'Can I search for matches based on specific preferences?',
    answer: 'Yes, our platform offers personalized filters such as location, education, profession, and more to help you find matches that truly align with your expectations.'
  },
  {
    question: 'What happens after I register?',
    answer: 'Once you register, our team verifies your profile and makes it visible to potential matches. You can also start browsing other verified members immediately.'
  },
  {
    question: 'Is customer support available to help me?',
    answer: 'Yes. We offer personal assistance via phone and email. If you ever face an issue or need guidance, we’re here to help you through every step.'
  }
];
